import Api from "../axios";

export const getNextReward = async () => {
  return await Api.get(`/Game/GetNextPlanId`);
};
